import { FallbackLogger } from '@fingermarkglobal/logger';

window.logger = window.logger || new FallbackLogger();

export { pay } from './pay';
export { refund } from './refund';
